/**
 * Utility functions for date formatting and manipulation
 */

/**
 * Get a local date string in YYYY-MM-DD format
 * @param {Date} date - The date to format (defaults to current date)
 * @returns {string} - Date string in YYYY-MM-DD format
 */
export const getLocalDateString = (date = new Date()) => {
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const day = date.getDate().toString().padStart(2, '0');
  return `${year}-${month}-${day}`;
};